export const conf2AccountLastName = {
  type: "string",
  minLength: 0,
  maxLength: 255,
  transform: ["trim", "toLowerCase"]
};
export const conf2AccountLastNameNullable = {
  ...conf2AccountLastName,
  type: ["null", "string"]
};
